import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SvgAirzone extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg viewBox="0 0 80.18 80.18" height={size}>
                <path
                    d="M40.11 80.18A40.09 40.09 0 1 0 0 40.09 40.17 40.17 0 0 0 40.11 80.2M19.34 63.42h4.82L30 47.26h19.79l5.83 16.15h8.08L44.74 11.09h-14.6v1.71c3.11.47 6 .55 6 3.65a32.11 32.11 0 0 1-1.34 4.64L19.34 63.42zm20.28-42.49l8.85 22.68H31.3l8.31-22.68z"
                    fill={color}
                    fillRule="evenodd"
                />
            </svg>
        );
    }
}

export default withTheme(SvgAirzone);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SvgAirzone.js